import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { PublicLayout } from "@/components/layout/PublicLayout";

export default function Properties() {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    api.get("/properties").then((r) => setProperties(r.data)).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <div className="mx-auto max-w-7xl px-6 pb-24 pt-36 lg:px-10">
        <p className="eyebrow fade-up">The Collection</p>
        <h1 className="fade-up mt-5 max-w-2xl font-serif text-4xl tracking-tight sm:text-5xl">
          Our Properties
        </h1>
        <p className="fade-up mt-5 max-w-xl font-sans text-base text-[var(--aur-text-2)]">
          Four singular estates, each shaped by its landscape. Select a destination to explore suites,
          offers, and to request your stay.
        </p>

        <div className="mt-16 space-y-8">
          {properties.map((p, i) => (
            <Link
              key={p.id}
              to={`/properties/${p.id}`}
              data-testid={`property-card-${p.slug}`}
              className="group grid overflow-hidden rounded-lg border border-[var(--aur-border)] bg-[var(--aur-card)] md:grid-cols-2"
            >
              <div className="aspect-[16/10] overflow-hidden md:aspect-auto">
                <img src={p.hero_image} alt={p.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="flex flex-col justify-center p-8 lg:p-12">
                <div className="mb-3 flex items-center gap-2 text-[var(--aur-text-2)]">
                  <MapPin size={13} className="text-gold" />
                  <span className="font-mono text-[10px] uppercase tracking-widest">{p.city}, {p.country}</span>
                </div>
                <h2 className="font-serif text-3xl tracking-tight">{p.name}</h2>
                <p className="mt-3 font-sans text-sm leading-relaxed text-[var(--aur-text-2)]">{p.description}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {p.amenities.slice(0, 4).map((a) => (
                    <span key={a} className="rounded-full border border-[var(--aur-border)] px-3 py-1 font-sans text-xs text-[var(--aur-text-2)]">{a}</span>
                  ))}
                </div>
                <span className="mt-8 flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-gold">
                  Explore <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
